import { io } from "socket.io-client";
import { socketURL } from "./config";

export const getTrackingHost = () => socketURL;

export const connectTrackingSocket = () => {
    
  const token = localStorage.getItem("__wasteknot");
  
  const trackingUrl = `${socketURL}/tracking`;

 const socket = io(trackingUrl, {      
  path: "/pickups-socket.io",               
  auth: { token },
  withCredentials: true,
  transports: ["polling", "websocket"],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 10000,
  timeout: 10000,
});

  return socket;
};
